import { render, staticRenderFns } from "./FieldsSelector.vue?vue&type=template&id=6b4f2524&"
import script from "./FieldsSelector.vue?vue&type=script&lang=js&"
export * from "./FieldsSelector.vue?vue&type=script&lang=js&"
import style0 from "./FieldsSelector.vue?vue&type=style&index=0&id=6b4f2524&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports